import { App } from '@/components/App.tsx';
import ReactGA from 'react-ga4';
import {
  retrieveLaunchParams,
  setMiniAppHeaderColor,
  themeParams,
  useSignal
} from "@telegram-apps/sdk-react";
import {mixHexColors} from "@/helpers/mixHexColors.ts";
import {datadogLogs} from "@datadog/browser-logs";

export function Root() {
  const lp = retrieveLaunchParams();

  const bgColor = useSignal(themeParams.backgroundColor);
  const secondaryBgColor = useSignal(themeParams.secondaryBackgroundColor);
  if (bgColor && secondaryBgColor && (bgColor === secondaryBgColor)) {
    const bgSectionColor = window.getComputedStyle(document.documentElement).getPropertyValue('--tg-theme-section-bg-color');
    const mixedSecondaryColor = mixHexColors(bgSectionColor, bgColor);
    document.documentElement.style.setProperty('--tg-theme-secondary-bg-color', mixedSecondaryColor);
    // @ts-expect-error it works
    setMiniAppHeaderColor(mixedSecondaryColor);
  }

  ReactGA.initialize('G-CV68YPPBHJ', {
    gaOptions: {
      userId: lp.initData?.user?.id?? undefined,
    },
  });
  ReactGA.event("start_app", {
    custom_source: lp.initData?.startParam || '(direct)',
    source: lp.initData?.startParam || '(direct)',
  });

  datadogLogs.init({
    clientToken: import.meta.env.MODE !== 'development' ?
      'pub09af652262f32023f475afc61e1e7d12' :
      '',
    // clientToken: 'pub09af652262f32023f475afc61e1e7d12',
    service: 'react-wishapp',
    site: 'datadoghq.eu',
    forwardErrorsToLogs: true,
    sessionSampleRate: 100,
    beforeSend: (event, context) => {
      if (event.error) {
        event.error.handlingStack = context.handlingStack;
      }

      if (event.message) {
        if (
          event.message.includes("DialogTitle") ||
          event.message.includes("google-analytics")
        ) {
          return false;
        }
      }

      return true;
    },
  })

  return (
    <div id="wrap">
      <div id="content" className={'pb-10'}>
        <App/>
      </div>
    </div>
  );
}
